/**
 * Returns true when url is a Loom CDN thumbnail that includes a signed Policy
 * (and thus expires). Such URLs should not be stored in ADF.
 * Public loom URLs do not include a Policy.
 */
export const isPrivateLoomImageUrl = (url: string): boolean => {
	return (
		typeof url === 'string' &&
		url.includes('cdn.loom.com') &&
		url.includes('/private')
	);
};

/**
 * Returns true when link looks like a Loom share URL (e.g. loom.com/share/).
 * Used to decide when to refetch a thumbnail at render.
 */
export const isLoomLink = (link: string): boolean => {
	if (typeof link !== 'string' || !link) {
		return false;
	}
	try {
		const host = new URL(link).hostname.toLowerCase();
		return (host === 'loom.com' || host === 'www.loom.com') && link.includes('/share/');
	} catch {
		return false;
	}
};
